export const QUARTERLY_LOOKBACK_MAX_YEARS = 5;
export const QUARTERLY_LOOKBACK_YEAR_OPTIONS = [1, 2, 5];

export function lookbackDateBounds(lookbackYears) {
  const years = Number(lookbackYears) > 0 ? Number(lookbackYears) : 1;
  const now = new Date();
  const start = new Date(
    Date.UTC(now.getUTCFullYear() - years, now.getUTCMonth(), 1, 0, 0, 0, 0)
  );
  return {
    dateFrom: start.toISOString().slice(0, 10),
    dateTo: now.toISOString(),
  };
}
